import { css } from '@emotion/react';
import { styled } from '@mui/joy';
import { Column, RowData, Table } from '@tanstack/react-table';
import { FunctionComponent, useState } from 'react';

import { TableHeaderCell } from '@/components/table/TableHeaderCell';

const Root = styled('thead')(
  () => css`
    position: sticky;
    top: 0;
    z-index: 101;
  `,
);

type TableHeadProps<TData extends RowData> = {
  table: Table<TData>;
  filters?: Record<string, FunctionComponent<{ column: Column<TData> }>>;
};

export function TableHead<TData extends RowData>({ table, filters }: TableHeadProps<TData>) {
  const [filterOpen, setFilterOpen] = useState<string>();

  const column = filterOpen && table.getColumn(filterOpen);
  const Filter = column && filters && filters[filterOpen];

  return (
    <Root>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <TableHeaderCell
              key={header.id}
              header={header}
              filterOpen={filterOpen}
              onFilterToggle={() => setFilterOpen((previous) => (previous !== header.id ? header.id : undefined))}
            />
          ))}
        </tr>
      ))}

      {Filter && (
        <tr>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <th style={{ fontWeight: 'normal' }} colSpan={table.getVisibleLeafColumns().length}>
            <Filter column={column} />
          </th>
        </tr>
      )}
    </Root>
  );
}
